import React from "react";
import PropTypes from "prop-types";
import { Box, ButtonGroupContainer, ButtonGroupItem } from "orcs-design-system";
import { useAllocationConfig } from "src/contexts/global/WorkspaceContext/WorkspaceContext";

export const MEMBERSHIP_TYPES = {
  DEMAND: "demand",
  SUPPLY: "supply",
};

export const MembershipTypeSwitcher = ({
  membershipType,
  handleMembershipTypeChange,
}) => {
  const { demandLabel, supplyLabel } = useAllocationConfig();

  return (
    <Box data-testid="group-type-toggle">
      <ButtonGroupContainer controlLabel="View:" labelDark>
        <ButtonGroupItem
          name="membershipType"
          label={demandLabel}
          value={MEMBERSHIP_TYPES.DEMAND}
          checked={membershipType === MEMBERSHIP_TYPES.DEMAND}
          onChange={handleMembershipTypeChange}
        />
        <ButtonGroupItem
          name="membershipType"
          label={supplyLabel}
          value={MEMBERSHIP_TYPES.SUPPLY}
          checked={membershipType === MEMBERSHIP_TYPES.SUPPLY}
          onChange={handleMembershipTypeChange}
        />
      </ButtonGroupContainer>
    </Box>
  );
};

MembershipTypeSwitcher.propTypes = {
  membershipType: PropTypes.string,
  handleMembershipTypeChange: PropTypes.func,
};
